var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00635 0C5.8851 0 3.84885 0.843375 2.3501 2.34313C0.849801 3.84347 0.00676324 5.87823 0.00634766 8C0.00634766 10.1209 0.850098 12.1571 2.3501 13.6569C3.84885 15.1566 5.8851 16 8.00635 16C10.1276 16 12.1638 15.1566 13.6626 13.6569C15.1626 12.1571 16.0063 10.1209 16.0063 8C16.0063 5.87913 15.1626 3.84288 13.6626 2.34313C12.1638 0.843375 10.1276 0 8.00635 0Z",
    fill: "url(#paint0_linear_13_289)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6276 7.9155C5.9601 6.8995 7.5151 6.22962 8.2926 5.906C10.5151 4.98187 10.9763 4.82137 11.2776 4.81593C11.3438 4.81487 11.4913 4.83125 11.5876 4.90906C11.6676 4.97468 11.6901 5.06343 11.7013 5.12575C11.7113 5.188 11.7251 5.32987 11.7138 5.44062C11.5938 6.70562 11.0726 9.77537 10.8076 11.1922C10.6963 11.7917 10.4751 11.9927 10.2613 12.0124C9.79635 12.0551 9.44385 11.7054 8.99385 11.4105C8.2901 10.9489 7.8926 10.6616 7.20885 10.2112C6.41885 9.69075 6.93135 9.40462 7.38135 8.93712C7.49885 8.81475 9.54635 6.95287 9.5851 6.784C9.5901 6.76287 9.5951 6.68412 9.5476 6.64262C9.50135 6.601 9.4326 6.61525 9.3826 6.6265C9.31135 6.6425 8.1876 7.386 6.0076 8.85687C5.68885 9.07612 5.4001 9.183 5.1401 9.17737C4.8551 9.17125 4.3051 9.01587 3.89635 8.88312C3.39635 8.72025 2.9976 8.63412 3.0326 8.3575C3.0501 8.2135 3.24885 8.06612 3.6276 7.9155Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_289",
    x1: 800.006,
    y1: 0,
    x2: 800.006,
    y2: 1600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.00634766)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.a3500e41f20db3731869bc2c8b238074.svg";
export { ForwardRef as ReactComponent };